export function TransactionError(message) {
  this.message = message;
}

export function TransactionRejectionError(message) {
  this.message = message;
}
